import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import Separator from "../../separator"
import { P } from "../../typography"
import Moment from "../../moment"
import { Container, A } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons"

const ParticipantSidebar = ({
  avatar_exists,
  avatar_path,
  display_name,
  first_name,
  last_name,
  age,
  gender,
  gender_info,
  country_code,
  placement_or_interview_status,
  english_rating,
  availability_from,
  availability_until,
  email,
  mobile_number,
  buttons,
  interview_plugin_enabled,
  availability_plugin_enabled,
  student_status,
  has_visa
}) => (
  <Container>
    <Grid gap="1rem">
      {placement_or_interview_status && placement_or_interview_status.length > 0 && (
        <>
          <Separator variant="secondary" size="small" margin="small" mobileOnly={false} />

          <Grid gap="0.5rem">
            <P size="medium" marginless bold align="center">
              Status:
            </P>
            <P marginless align="center">
              {placement_or_interview_status}
            </P>
          </Grid>
        </>
      )}

      <Separator variant="secondary" size="small" margin="small" mobileOnly={false} />

      {has_visa && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            Visa received:
          </P>
          <P marginless align="center">
            Yes
          </P>
        </Grid>
      )}

      {interview_plugin_enabled && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            English rating:
          </P>
          <P marginless align="center">
            {english_rating || "-"}
          </P>
        </Grid>
      )}

      {student_status && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            Student status:
          </P>
          <P marginless align="center">
            {student_status}
          </P>
        </Grid>
      )}
      {availability_plugin_enabled && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            Availability:
          </P>
          <P marginless align="center">
            {availability_from && availability_until ? (
              <>
                <Moment value={availability_from} blank="-" />
                &nbsp;to&nbsp;
                <Moment value={availability_until} blank="-" />
              </>
            ) : (
              "-"
            )}
          </P>
        </Grid>
      )}
      {gender_info && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            I describe myself as:
          </P>
          <P marginless align="center">
            {gender_info}
          </P>
        </Grid>
      )}
      {(email || mobile_number) && (
        <Grid gap="0.5rem">
          <P size="medium" marginless bold align="center">
            Contact:
          </P>
          <P marginless align="center">
            <span>
              <FontAwesomeIcon icon={faEnvelope} /> <A href={`mailto:${email}`}>{email}</A>
              <br />
            </span>
            <span>
              <FontAwesomeIcon icon={faPhone} /> {mobile_number}
            </span>
          </P>
        </Grid>
      )}
    </Grid>
    <Grid gap="0.5rem">{buttons !== undefined && buttons}</Grid>
  </Container>
)

ParticipantSidebar.propTypes = {
  avatar_exists: PropTypes.bool,
  avatar_path: PropTypes.string,
  display_name: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  age: PropTypes.string,
  gender: PropTypes.string,
  gender_info: PropTypes.string,
  country_code: PropTypes.string,
  english_rating: PropTypes.string,
  availability_from: PropTypes.string,
  availability_until: PropTypes.string,
  email: PropTypes.string,
  mobile_number: PropTypes.string,
  buttons: PropTypes.node
}

ParticipantSidebar.defaultProps = {
  avatar_exists: true,
  avatar_path: "",
  display_name: "",
  first_name: "",
  last_name: "",
  age: "",
  gender: "",
  gender_info: "",
  country_code: "",
  english_rating: "",
  availability_from: "",
  availability_until: "",
  email: "",
  mobile_number: "",
  buttons: undefined
}

export default ParticipantSidebar
